import React from 'react';

import { faListAlt } from '@fortawesome/pro-regular-svg-icons';

import StrongTextField from '../components/StrongTextField';

export default {
  name: 'passerelles',
  title: 'Passerelles',
  icon: faListAlt,
  resource: 'passerelle',
  primaryKey: 'passerelle_id',
  query: { _associations: 'promoteur' },
  head: {
    passerelle_name: 'Nom',
    passerelle_idpromoteur: 'Promoteur',
    passerelle_last_launch: 'Date MàJ',
  },
  sort: '-passerelle_last_launch',
  list: ({ values }) => [values.passerelle_name, values.promoteur?.nom, values.passerelle_last_launch],
  filter: ({ values, props }) => [
    <StrongTextField name='passerelle_name' label='Nom' values={values.passerelle_name} {...props} />,
  ],
};
